import { render, staticRenderFns } from "./T9.vue?vue&type=template&id=5481b6e0&"
import script from "./T9.vue?vue&type=script&lang=js&"
export * from "./T9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports